"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractArticleService = _interopRequireDefault(require("../AbstractArticleService"));

var _DexfWebPlannerParser = _interopRequireDefault(require("./DexfWebPlannerParser"));

var _ServiceSettings = _interopRequireDefault(require("../../../ServiceSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _asyncIterator(iterable) { var method; if (typeof Symbol !== "undefined") { if (Symbol.asyncIterator) { method = iterable[Symbol.asyncIterator]; if (method != null) return method.call(iterable); } if (Symbol.iterator) { method = iterable[Symbol.iterator]; if (method != null) return method.call(iterable); } } throw new TypeError("Object is not async iterable"); }

/**
 * This class is used for fetching article data from IKEA Item Retail Service
 */
var DexfWebPlannerService = /*#__PURE__*/function (_AbstractArticleServi) {
  _inherits(DexfWebPlannerService, _AbstractArticleServi);

  var _super = _createSuper(DexfWebPlannerService);

  function DexfWebPlannerService() {
    _classCallCheck(this, DexfWebPlannerService);

    return _super.apply(this, arguments);
  }

  _createClass(DexfWebPlannerService, [{
    key: "getItems",

    /**
     * Fetches items from DEXF.
     *
     * @param {ArticleServiceConfig} config Service config.
     * @param {Object[]} items Array of items.
     * @return {Promise} Promise object.
     */
    value: function getItems(config, items) {
      var _this = this;

      this._cleanIdFromUnderscore(items);

      return new Promise(function (resolve, reject) {
        var baseUrl = _this._getBaseUrl(config.endpoints.dexfWebplannerService, config.apiLocalePath);

        var promises = [];

        var sets = _this._getItemSets({
          items: _this._sortItemsById(items),
          avoidOneItem: false
        });

        var fields = config.fields ? config.fields.join(',') : '*';
        var options = {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'DEXF-API-KEY': config.dexfApiKey
          }
        };

        var _iterator2 = _createForOfIteratorHelper(sets),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var itemSet = _step2.value;
            var url = "".concat(baseUrl, "?filter.itemId=").concat(_this._getItemsString(itemSet), "&fields=").concat(fields, "&filter.valid=true");
            promises.push(fetch(url, options).then(_this._handleJsonResponse.bind(_this)));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        Promise.all(promises).then( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dataParts) {
            var parser, articles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, part;

            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    parser = new _DexfWebPlannerParser.default(config);
                    articles = [];
                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _context.prev = 4;
                    _iterator = _asyncIterator(dataParts);

                  case 6:
                    _context.next = 8;
                    return _iterator.next();

                  case 8:
                    _step = _context.sent;
                    _iteratorNormalCompletion = _step.done;
                    _context.next = 12;
                    return _step.value;

                  case 12:
                    _value = _context.sent;

                    if (_iteratorNormalCompletion) {
                      _context.next = 24;
                      break;
                    }

                    part = _value;

                    if (!(part && part.data)) {
                      _context.next = 21;
                      break;
                    }

                    _context.t0 = articles;
                    _context.next = 19;
                    return parser.parse(part.data);

                  case 19:
                    _context.t1 = _context.sent;
                    articles = _context.t0.concat.call(_context.t0, _context.t1);

                  case 21:
                    _iteratorNormalCompletion = true;
                    _context.next = 6;
                    break;

                  case 24:
                    _context.next = 30;
                    break;

                  case 26:
                    _context.prev = 26;
                    _context.t2 = _context["catch"](4);
                    _didIteratorError = true;
                    _iteratorError = _context.t2;

                  case 30:
                    _context.prev = 30;
                    _context.prev = 31;

                    if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                      _context.next = 35;
                      break;
                    }

                    _context.next = 35;
                    return _iterator.return();

                  case 35:
                    _context.prev = 35;

                    if (!_didIteratorError) {
                      _context.next = 38;
                      break;
                    }

                    throw _iteratorError;

                  case 38:
                    return _context.finish(35);

                  case 39:
                    return _context.finish(30);

                  case 40:
                    resolve(articles);

                  case 41:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[4, 26, 30, 40], [31,, 35, 39]]);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(_this._rejectWrapper.bind(_this, reject));
      });
    }
    /**
     * Fetches all items assigned to an application from DEXF.
     *
     * @param {ArticleServiceConfig} config Service config.
     * @return {Promise} Promise object.
     */

  }, {
    key: "getApplicationItems",
    value: function getApplicationItems(config) {
      var _this2 = this;

      var baseUrl = this._getBaseUrl(config.endpoints.dexfWebplannerService, config.apiLocalePath);

      var appId = _ServiceSettings.default.dexfApplicationId || _ServiceSettings.default.applicationName;
      var fields = config.fields ? config.fields.join(',') : '*';
      var url = "".concat(baseUrl, "?filter.appId=").concat(appId, "&fields=").concat(fields, "&filter.valid=true");
      return new Promise(function (resolve, reject) {
        fetch(url, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'DEXF-API-KEY': config.dexfApiKey
          }
        }).then(_this2._handleJsonResponse.bind(_this2)).then(function (response) {
          var parser = new _DexfWebPlannerParser.default(config);
          resolve(parser.parse(response.data));
        }).catch(_this2._rejectWrapper.bind(_this2, reject));
      });
    }
    /**
     * Returns the parser used by the service. To enable cacheRawData.
     *
     * @param {ArticleServiceConfig} config Service config.
     * @return {Function} class.
     */

  }, {
    key: "getParser",
    value: function getParser(config) {
      return new _DexfWebPlannerParser.default(config);
    }
    /**
     * Returns the maximum allowed items per request for RetailItemComm.
     *
     * @return {Number} Maximum allowed items per request.
     */

  }, {
    key: "_getMaxItemsPerRequest",
    value: function _getMaxItemsPerRequest() {
      return 50;
    }
    /**
     * Returns an item string to be used in the request URL.
     *
     * @param {Object[]} itemsSet Array of items.
     * @return {String} Item string.
     */

  }, {
    key: "_getItemsString",
    value: function _getItemsString(itemsSet) {
      var itemsString = '';

      var _iterator3 = _createForOfIteratorHelper(itemsSet),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          itemsString += item.type.toUpperCase() + '-' + item.id + ',';
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      itemsString = itemsString.slice(0, -1);
      return itemsString;
    }
    /**
     * Returns the base URL to be used in request.
     *
     * @param {String} endpoint Api endpoint.
     * @param {String} apiLocalePath API locale path. Example: "gb/en".
     * @return {String} Base URL.
     */

  }, {
    key: "_getBaseUrl",
    value: function _getBaseUrl(endpoint, apiLocalePath) {
      var retailUnit = apiLocalePath.substr(0, 2).toUpperCase();
      var languageCode = apiLocalePath.substr(3, 2);
      var locale = languageCode + '-' + retailUnit;
      return endpoint.replace('{retailUnit}', retailUnit).replace('{locale}', locale);
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @return {String} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'dexfwebplanner';
    }
  }]);

  return DexfWebPlannerService;
}(_AbstractArticleService.default);

exports.default = DexfWebPlannerService;